import * as Sentry from '@sentry/react';

export const sentryInit = () => {
  import.meta.env.MODE !== 'development' &&
    Sentry.init({
      dsn: 'https://eb2fce8218c5490f87b3e0ebcdbb715d@o4504446034444288.ingest.sentry.io/4504446037196800',
      integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      environment: import.meta.env.MODE,
      release: import.meta.env.__GIT_COMMIT_HASH__ ?? 'development',
    });
};
